import { useApplicationStore } from '@data';
import { usePatientWebUrl } from 'data/slices/devTools/hooks/usePatientWebUrl';
interface BuildPatientAppUrlParams {
  page: string;
  params?: Record<string, string | undefined>;
}

export function useBuildPatientAppUrl({
  page,
  params,
}: BuildPatientAppUrlParams) {
  const auth = useApplicationStore((state) => state.auth);
  const { accessToken, sessionId } = auth;

  const searchParams = new URLSearchParams({
    accessToken: accessToken || '',
    sessionId: sessionId || '',
    redirectTo: page,
  });

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (!value) {
        return;
      }

      searchParams.append(key, value);
    });
  }

  const { patientWebUrl } = usePatientWebUrl();

  return `${patientWebUrl}/auth/validate?${searchParams.toString()}`;
}
